angular
    .module('app')
    .factory('StoredItemsService', function ($timeout, $localStorage) {
    const fac = {
        save: save,
        load: load,
        unselectedItem: unselectedItem,
        unselectedItems: unselectedItems,
        storeTester: storeTester,
        storeSim: storeSim,
        storeSuite: storeSuite,
        storeTest: storeTest,
        remove: remove
    };
    return fac;
    function save(storedItems) {
        return $timeout(function () {
            $localStorage.storedItems = storedItems;
        });
    }
    function load() {
        return $timeout(function () {
            const storedItems = $localStorage.storedItems;
            const addedMissingKeys = addMissingKeys(storedItems);
            const correctHierarchy = checkHierarchy(addedMissingKeys);
            return correctHierarchy || unselectedItems();
        });
    }
    function unselectedItem() {
        const item = { Id: -1, Name: 'Not selected' };
        return item;
    }
    function unselectedItems() {
        const storedItems = {
            tester: unselectedItem(),
            sim: unselectedItem(),
            suite: unselectedItem(),
            test: unselectedItem()
        };
        return storedItems;
    }
    function storeTester(tester) {
        return load().then(function (data) {
            data.tester = tester;
            save(data);
        });
    }
    function storeSim(sim) {
        return load().then(function (data) {
            data.sim = sim;
            save(data);
        });
    }
    function storeSuite(suite) {
        return load().then(function (data) {
            data.suite = suite;
            save(data);
        });
    }
    function storeTest(test) {
        return load().then(function (data) {
            data.test = test;
            save(data);
        });
    }
    function remove() {
        delete $localStorage.storedItems;
        return true;
    }
    function checkHierarchy(storedItems) {
        if (storedItems.tester.Id === -1) {
            storedItems.sim = unselectedItem();
            storedItems.suite = unselectedItem();
            storedItems.test = unselectedItem();
        }
        if (storedItems.sim.Id === -1) {
            storedItems.suite = unselectedItem();
            storedItems.test = unselectedItem();
        }
        if (storedItems.suite.Id === -1) {
            storedItems.test = unselectedItem();
        }
        return storedItems;
    }
    /**
     * Fix any missing keys in stored items
     */
    function addMissingKeys(storedItems) {
        if (!storedItems) {
            return unselectedItems();
        }
        if (!storedItems.hasOwnProperty('tester')) {
            storedItems.tester = unselectedItem();
            storedItems.sim = unselectedItem();
            storedItems.suite = unselectedItem();
            storedItems.test = unselectedItem();
        }
        if (!storedItems.hasOwnProperty('sim')) {
            storedItems.sim = unselectedItem();
            storedItems.suite = unselectedItem();
            storedItems.test = unselectedItem();
        }
        if (!storedItems.hasOwnProperty('suite')) {
            storedItems.suite = unselectedItem();
            storedItems.test = unselectedItem();
        }
        if (!storedItems.hasOwnProperty('test')) {
            storedItems.test = unselectedItem();
        }
        return storedItems;
    }
});
